import { ca } from '@cian/analytics';

interface IOptions {
  buttonType: 'prev' | 'next';
}

const ACTIONS = {
  prev: 'property_guides_click_left',
  next: 'property_guides_click_right',
};

export function trackSliderClick({ buttonType }: IOptions) {
  ca('eventSite', {
    category: 'main_page',
    action: ACTIONS[buttonType],
  });
}
